import { render } from "./Endpoint.vue?vue&type=template&id=481ae504"
import script from "./Endpoint.vue?vue&type=script&lang=js"
export * from "./Endpoint.vue?vue&type=script&lang=js"

import "./Endpoint.vue?vue&type=style&index=0&id=481ae504&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__